import { Link } from 'react-router'
import { AnalyticsProduct } from '@/domain/products'

const ProductCard = (product: AnalyticsProduct) => {
  const productReference = product.reference
  return (
    <Link
      to={`/analytics/products/${product.id}`}
      key={product.id}
      className="flex cursor-pointer flex-col overflow-hidden rounded-lg border border-solid border-[#ccc] bg-white shadow-sm"
    >
      <div
        style={{ backgroundImage: `url(${product.imageURL})` }}
        className="h-32 w-full rounded-b-lg bg-cover bg-center bg-no-repeat"
      />
      <div className="flex grow flex-col justify-between p-2">
        <div className="flex flex-col justify-center">
          <p className="mb-1 text-center text-sm">{product.name}</p>
        </div>

        <div>
          <div className="flex justify-center">
            <div className="rounded-lg bg-[#eee] px-2 py-1">
              <p className="text-center text-xs">
                {'ID: ' + product.id}
                {productReference ? ' / ' + productReference : ''}
              </p>
            </div>
          </div>

          <div className="mt-2 flex items-baseline justify-center gap-2">
            <h4>{product.totalReturns}</h4>
            <p className="text-xs">
              {product.totalReturns && product.totalReturns > 1
                ? 'returns'
                : 'return'}
            </p>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default ProductCard
